(function () {
  function initIngredientSlider(root) {
    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-index]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-dot]'));
    var nextButton = root.querySelector('[data-ingredient-next]');
    var prevButton = root.querySelector('[data-ingredient-prev]');

    if (!slides.length) return;

    var total = slides.length;
    var currentIndex = 0;

    function setActive(index) {
      if (index < 0 || index >= total) return;
      currentIndex = index;

      pins.forEach(function (pin) {
        var pinIndex = parseInt(pin.getAttribute('data-ingredient-index'), 10);
        pin.classList.toggle('wt-dot--active', pinIndex === currentIndex);
      });

      slides.forEach(function (slide) {
        var slideIndex = parseInt(slide.getAttribute('data-ingredient-slide'), 10);
        slide.classList.toggle('is-active', slideIndex === currentIndex);
      });

      dots.forEach(function (dot) {
        var dotIndex = parseInt(dot.getAttribute('data-ingredient-dot'), 10);
        dot.classList.toggle('is-active', dotIndex === currentIndex);
      });
    }

    pins.forEach(function (pin) {
      pin.addEventListener('click', function () {
        var index = parseInt(pin.getAttribute('data-ingredient-index'), 10);
        setActive(index);
      });
      pin.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          var index = parseInt(pin.getAttribute('data-ingredient-index'), 10);
          setActive(index);
        }
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-ingredient-dot'), 10);
        setActive(index);
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        setActive((currentIndex + 1) % total);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        setActive((currentIndex - 1 + total) % total);
      });
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ingredient-slider]');
    roots.forEach(function (root) {
      initIngredientSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var roots = event.target.querySelectorAll('[data-ingredient-slider]');
    roots.forEach(function (root) {
      initIngredientSlider(root);
    });
  });
})();
